import { Link, useMatch, useResolvedPath, useLocation} from "react-router-dom";
import CustomLink from "./customlink";
import React from "react";
import Logo from "../../images/mdm2025.png";

const Navbar = () => {

    // this is to make the nav bar text a different color on the homepage
    const location = useLocation();
    const isHome = location.pathname === "/";

    return (
        <nav className="nav">
            <Link to="/" className="site-name">
                {/*<span>MDM-2025</span>*/}
                {/*<img src="/MDM.png" alt="MDM" className="logo-image" />*/}
                <img src="/team/MDM-logo-general-circle.png" alt="MDM" className="logo-image" />
                {/*<img id="test-home" src={Logo} alt={"MDM 2025 Logo"} loading="lazy"/>*/}
            </Link>
            <ul className={isHome ? "nav-list home-style" : "nav-list"}>
                <CustomLink to="https://docs.google.com/document/d/16ACk3mn0-ccgPWc5XxEWJ8Xjkea3NX8CtmQ1pKOp9QM/preview?tab=t.0" target="_blank" rel="noopener noreferrer">Schedule</CustomLink>
                <CustomLink to="https://docs.google.com/forms/d/e/1FAIpQLScjvMmbsA8eKhy9Wpo2EhJRyX9PpIvn9LMeIO_3y5WEb2gUfQ/viewform?usp=sharing&ouid=102726862521755160153" target="_blank" rel="noopener noreferrer">Registration Form</CustomLink>
                {/*<CustomLink to="/register">Registration</CustomLink>*/}
                <CustomLink to="/sponsor">Sponsorship</CustomLink>
                <CustomLink to="/previous-competitions">Past Competitions</CustomLink>
                <CustomLink to="/team">Meet Our Team</CustomLink>
                {/*<CustomLink to="/explore">Explore</CustomLink>*/}
                <CustomLink to="/contact">Contact Us</CustomLink>

            </ul>
        </nav>
    )
}
export default Navbar;
